/* eslint-disable import/first */
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import angrySmile from './images/angry.svg';
import sadSmile from './images/sad.svg';
import okSmile from './images/smile.svg';
import winkSmile from './images/wink.svg';
import loveSmile from './images/in-love.svg';
import Star from '../../components/Star';
import css from './index.module.scss';

const iconSmile = {
  0: angrySmile,
  1: sadSmile,
  2: okSmile,
  3: winkSmile,
  4: loveSmile,
};

const FeedbackHeader = ({ smileIndex, onSmileyChosen, gradeIndex, onGradeIndexChosen }) => {
  const GRADES = [
    <FormattedMessage id="feedback_rating_notGood" defaultMessage="Not So Good" />,
    <FormattedMessage id="feedback_rating_canbeBetter" defaultMessage="Can be Better" />,
    <FormattedMessage id="feedback_rating_satisfactory" defaultMessage="Satisfactory" />,
    <FormattedMessage id="feedback_rating_delightful" defaultMessage="Delightful" />,
    <FormattedMessage id="feedback_rating_mouthWatering" defaultMessage="Mouth Watering" />,
  ];
  const activeStar = {
    fill: '#ec002d',
  };

  return (
    <Grid className={css.ratingBox}>
      <Grid className={css.flexBox}>
        <img
          alt=""
          className={css.ratingIcon}
          src={smileIndex !== -1 ? iconSmile[smileIndex] : okSmile}
        />
      </Grid>
      <Grid className={css.flexBox}>
        <Grid>
          <Typography className={css.result}>
            {GRADES[gradeIndex] ? (
              GRADES[gradeIndex]
            ) : (
              <FormattedMessage id="feedback_rateus" defaultMessage="Rate Us" />
            )}
          </Typography>
        </Grid>
      </Grid>
      <Grid className={css.flexBox}>
        <div className={css.stars}>
          {GRADES.map((grade, index) => {
            return (
              <Star
                index={index}
                key={grade}
                changeGradeIndex={() => onGradeIndexChosen(index)}
                changeSmileIndex={() => onSmileyChosen(index)}
                type={gradeIndex >= index || index < smileIndex ? 'active' : 'default'}
                style={gradeIndex >= index || smileIndex >= index ? activeStar : {}}
              />
            );
          })}
        </div>
      </Grid>
    </Grid>
  );
};

export default FeedbackHeader;
